import { render, staticRenderFns } from "./BlackFridayForm.vue?vue&type=template&id=4782e0aa&scoped=true&"
import script from "./BlackFridayForm.vue?vue&type=script&lang=js&"
export * from "./BlackFridayForm.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayForm.vue?vue&type=style&index=0&id=4782e0aa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782e0aa",
  null
  
)

export default component.exports